import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=4d868f16"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"
import style0 from "./Certification.vue?vue&type=style&index=0&id=4d868f16&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports